import { apiFetch } from './client'
import type { LeaderboardEntry, PlayerGroup } from '@/types/scoring'

export const fetchLeaderboard = (groupId?: string) =>
  apiFetch<LeaderboardEntry[]>(`/leaderboard${groupId ? `?group=${encodeURIComponent(groupId)}` : ''}`)

export const fetchGroups = () =>
  apiFetch<PlayerGroup[]>('/groups')
